export default __webpack_public_path__ + "static/media/276.dbcc650f.svg";